<template>
  <div id="chart-line-item-item-box">
    <chart-title
      leftTitle="TQC家具售后出错类型 left_5"
      :rightTitle="`${formatTime(date, 'yyyy年MM月')} 合计：${totalNum}`"
      :tooltipText="'售后统计实时数据'"
    ></chart-title>
    <date-change-card
      height="calc(100% - 30px)"
      @leftClick="leftClick"
      @rightClick="rightClick"
    >
      <div id="left_5" slot="main" />
    </date-change-card>
  </div>
</template>

<script>
import { errorType } from "@/api/cockpit/jyl";
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
import { formatTime, getFirstDate, getNextMonth} from "@/utils";
export default {
  mixins: [resize],
  name: "left_5",
  components: { ChartTitle, DateChangeCard },
  data() {
    return {
      date: new Date(),
      chart: null,
      totalNum: 0,
      chartData: []
    };
  },
  props: {},
  created() {},
  mounted() {
    this.getData();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    formatTime,
    getData(){

      //初始化数据
      this.totalNum = 0;
      this.chartData = [
        { value: 0, name: "尺寸出错" },
        { value: 0, name: "材料出错" },
        { value: 0, name: "颜色出错" },
        { value: 0, name: "结构出错" },
        { value: 0, name: "少开板件" },
        { value: 0, name: "拉槽出错" },
        { value: 0, name: "孔位出错" },
        { value: 0, name: "五金出错" },
        { value: 0, name: "其他出错" },
      ]

      //获取ERP 接口数据
      errorType(
          {'dayTime':getFirstDate(this.date, "yyyy-MM-dd")}
      ).then((resp) => {
        //处理数据
        if(resp.data.家具) {
          for (let i = 0; i < this.chartData.length; i++) {
            for (let key in resp.data.家具) {
              if (this.chartData[i].name === key) {
                this.totalNum += resp.data.家具[key];
                this.chartData[i].value = resp.data.家具[key];
                break;
              }
            }
          }
        }

        this.initChart();
      });

    },
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("left_5"));
      this.setOptions();
    },
    setOptions() {
      this.chart.setOption({
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "horizontal",
          left: "center",
          bottom: "3%",
          textStyle: {
            color: "#C0C4CC",
            fontSize: "10",
          },
        },
        color: [
          "#1158a7",
          "#4682B4",
          "#0983ff",
          "#59abf6",
          "#abd6fc",
          "#29beb9",
          "#3bffd0",
          "#22e4ff",
          "#40E0D0",
        ],
        series: [
          {
            name: "TQC售后出错类型",
            type: "pie",
            radius: "42%",
            center: "center",
            top: "-10%",
            data: this.chartData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              formatter: "{b}：{@2012}",
              color: "#C0C4CC",
            },
          },
        ],
      });
    },
    //前一月
    leftClick() {
      this.date = getNextMonth(formatTime(this.date, "yyyy-MM-dd"), -1);
      this.getData();
    },
    //后一月
    rightClick() {
      this.date = getNextMonth(formatTime(this.date, "yyyy-MM-dd"), +1);
      this.getData();
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 40vh;
  #left_5 {
    height: 100%;
  }
}
</style>
